// The design-workspace empty state (pwa-design@insights): art + title +
// explainer + «Начать разговор» CTA. Same block for the card screens; the
// copy comes from the call site.

import { Link } from 'react-router-dom'
import styles from './InsightsEmpty.module.css'

export default function InsightsEmpty({ title, text }: { title: string; text: string }) {
  return (
    <div className={styles.empty}>
      <svg className={styles.art} viewBox="0 0 148 112" fill="none" aria-hidden="true">
        <path d="M78 18c18 0 32 12 32 28 0 16-14 28-32 28H66l-14 12v-12c-10-4-16-14-16-28 0-16 14-28 32-28h10Z" fill="#D7E7FB" />
        <path d="M46 34c16 0 28 11 28 25s-12 25-28 25H36l-12 10V84c-8-4-14-12-14-25 0-14 12-25 26-25h10Z" fill="#EEF5FD" />
        <circle cx="34" cy="59" r="3.2" fill="#B7CFF0" />
        <circle cx="46" cy="59" r="3.2" fill="#B7CFF0" />
        <circle cx="58" cy="59" r="3.2" fill="#B7CFF0" />
      </svg>
      <h2 className={styles.emptyTitle}>{title}</h2>
      <p className={styles.emptyText}>{text}</p>
      <Link className={styles.emptyBtn} to="/">Начать разговор →</Link>
    </div>
  )
}
